import {
  MASTERY_PAGE_PRESETS,
  listMasteryPagePresetIds
} from '../../domain/masteries/masteryCatalog.js';

/**
 * lobbyMasterySelect — populate/bind mastery page dropdown.
 */
export function populateLobbyMasterySelect(selectEl, selectedId) {
  if (!selectEl) return;
  const ids = listMasteryPagePresetIds();
  selectEl.innerHTML = ids.map((id) => {
    const page = MASTERY_PAGE_PRESETS[id];
    const selected = id === selectedId ? 'selected' : '';
    return `<option value="${id}" ${selected}>${page.name}</option>`;
  }).join('');
}

export function bindLobbyMasterySelect(selectEl, session, onChange) {
  if (!selectEl || !session) return;
  selectEl.addEventListener('change', (e) => {
    if (!session.setMasteryPage(e.target.value)) {
      e.target.value = session.masteryPage;
      return;
    }
    if (typeof onChange === 'function') onChange();
  });
}
